<mat-form-field appearance="outline" class="chat-input-field">
  <div class="textarea-container">
    <textarea
      matInput
      #userInput
      class="chat-input"
      [placeholder]="'chat.askAQuestion' | translate"
      rows="3"
      autocomplete="no-autofill"
      [ngModel]="messageValue()"
      (ngModelChange)="onMessageChange($event)"
      (keydown.enter)="isResponseInProgress() ? $event.preventDefault() : send()"
    ></textarea>
    <div class="chat-input-buttons">
      @if (true) {
        <div
          class="view-all-prompts"
          [class.disabled]="isResponseInProgress()"
          (click)="isResponseInProgress() ? $event.stopPropagation() : showPromptsPanel()"
          >
          <mat-icon svgIcon="magic"></mat-icon>
          <a href="javascript:void()">{{ 'chat.viewAllPrompts' | translate }}</a>
        </div>
      } @else {
        <span style="visibility: hidden">Placeholder</span>
      }
      <div
        class="send-button"
        [class.disabled]="!userInput.value || isResponseInProgress()"
        (click)="!userInput.value ? $event.stopPropagation() : send()"
        >
        <mat-icon (click)="send()">send</mat-icon>
      </div>
    </div>
  </div>
</mat-form-field>
